export const UserRoleEnum = {
  ADMIN: 'ADMIN',
  AUDITOR: 'AUDITOR',
  AUDIT_MANAGER: 'AUDIT_MANAGER',
  BACK_OFFICE: 'BACK_OFFICE',
  CUSTOMER: 'CUSTOMER',
  DEALER_MANAGER: 'DEALER_MANAGER',
  GROUP_MANAGER: 'GROUP_MANAGER',
  INTEGRATION: 'INTEGRATION',
  KEY_DEPOSIT_MANAGER: 'KEY_DEPOSIT_MANAGER',
  MANUFACTURER: 'MANUFACTURER',
  NO_CONFIGURATION_ACCESS: 'NO_CONFIGURATION_ACCESS',
  READ_ONLY: 'READ_ONLY',
  SALESMAN: 'SALESMAN',
  SCHEDULER: 'SCHEDULER',
  TECHNICIAN: 'TECHNICIAN',
  VO_STOCK_MANAGER: 'VO_STOCK_MANAGER',
  PARTS_MANAGER: 'PARTS_MANAGER',
  PARTS_OFFICER: 'PARTS_OFFICER'
} as const;
export type UserRoleEnum = typeof UserRoleEnum[keyof typeof UserRoleEnum];

export const UserStatusEnum = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
} as const;
export type UserStatusEnum = typeof UserStatusEnum[keyof typeof UserStatusEnum];

export const UserTypeEnum = {
  DEVICE: 'DEVICE',
  USER: 'USER',
  SYSTEM: 'SYSTEM'
} as const;
export type UserTypeEnum = typeof UserTypeEnum[keyof typeof UserTypeEnum];

export const WarningTypeEnum = {
  deletePersonalDevices: 'deletePersonalDevices',
  deleteRoles: 'deleteRoles',
  inactive: 'inactive'
} as const;
export type WarningTypeEnum = typeof WarningTypeEnum[keyof typeof WarningTypeEnum];
